import { render, staticRenderFns } from "./CostInfo.vue?vue&type=template&id=0f99a434&scoped=true"
import script from "./CostInfo.vue?vue&type=script&lang=js"
export * from "./CostInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f99a434",
  null
  
)

export default component.exports